import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import closeIcon from '../img/close.png';
import './css/mobilePop.less';

const MenuPopup = ({ title = "JuChain Mainnet", onClose, onChildMenuAction }) => {
    const [openKeys, setOpenKeys] = useState<string[]>([]);

    const handleMenuClick = (key: string, index?: number) => {
        if (key == "0" || key == '1') {
            onChildMenuAction(key, key);
            onClose();
        } else if (index === 0 || index === 1) {
            onChildMenuAction(key, index,'JuChan');
            onClose();
        }
    };

    // 菜单项数据
    const items = [
        {
            key: "0",
            label: "Issue token",
            onClick: () => handleMenuClick("0"),
        },
        {
            key: "1",
            label: "Batch airdrop",
            onClick: () => handleMenuClick("1"),
        },
        {
            key: "2",
            label: title,
            children: [
                {
                    key: "2-0",
                    label: "JuChain Mainnet",
                    onClick: () => handleMenuClick("JuChain Mainnet", 0),
                },
                {
                    key: "2-1",
                    label: "JuChain Testnet",
                    onClick: () => handleMenuClick("JuChain Testnet", 1),
                },
            ],
        },
    ];

    return (
        <div className="wholePages">
            <div className="topImg">
                <img src="/icon/logo.png" alt="Logo" />
                <img src={closeIcon} alt="Close" onClick={onClose} style={{ cursor: "pointer" }} />
            </div>
            <Menu
                theme="dark"
                mode="inline"
                style={{ backgroundColor: "#06060B", color: "#ffffff" }}
                openKeys={openKeys}
                onOpenChange={setOpenKeys}
                items={items}
            />
        </div>
    );
};

export default MenuPopup;
